import React from 'react';

/**
 * Renders an authentication button component.
 *
 * @param {Object} props - The component props.
 * @param {string} props.errorType - The type of error.
 * @param {Object} props.aemProdInfo - The AEM product information.
 * @returns {JSX.Element} The rendered authentication button component.
 */
const AuthButton = (props) => {
	const isSelectCustomerError = props.errorType === 'selectCustomerNumberMessage';
	const labels = {
		logIntoSeePriceMessage: {
			linkUrl: 'loginToSeePriceURL',
			linkMssg: 'loginToSeePriceTextMssg',
			btnLabel: 'loginToSeePriceBtnLabel',
		},
		verificationMessage: {
			linkUrl: 'veryfyURL',
			linkMssg: 'verifyTextMssg',
			btnLabel: 'verifyBtnLabel',
		},
		logIntoVerifyMessage: {
			linkUrl: 'signinURL',
			linkMssg: 'signinTextMssg',
			btnLabel: 'signinBtnLabel',
		},
		selectCustomerNumberMessage: {
			linkUrl: 'scnURL',
			linkMssg: 'scnTextMssg',
			btnLabel: 'scnBtnLabel',
		},
	};
	const currLabelsKey = labels[props.errorType];
	const btnLabel = props.aemProdInfo?.[currLabelsKey?.btnLabel];
	const linkUrl = props.aemProdInfo?.[currLabelsKey?.linkUrl];

	if (!btnLabel) {
		return null;
	}

	/**
	 * Redirects to the customer number page.
	 */
	const goToCustomerNumberPage = () => {
		window.location.href = linkUrl;
	};

	return (
		<calcite-button
			onClick={isSelectCustomerError ? goToCustomerNumberPage : undefined}
			href={!isSelectCustomerError ? linkUrl : undefined}
			width="full"
			scale="l"
			className="prc__add-to-cart">
			<span>{btnLabel}</span>
		</calcite-button>
	);
};

export default AuthButton;
